module.exports = __webpack_public_path__ + "img/SWP_Sword_1H_05 (1).aea613ac.png";